<template>
	<div>
		<footer>
			<nav
				class="nav"
				:class="{ authenticated: authenticated, virtual: virtual }"
			>
				<a
					@click="goTo('/', 'home')"
					:class="{ nav__item: 1, active: $route.path == '/' }"
				>
					<svg
						:class="{ nav__item__icon: 1 }"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M3 10.2222L11.6389 4L20.2778 10.2222M18.5 9.33333L17.7198 18.1758C17.6287 19.2082 16.764 20 15.7275 20H13.7361H9.54167H7.55025C6.51381 20 5.64909 19.2082 5.55799 18.1758L4.77778 9.33333"
							stroke=""
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<circle
							cx="11.753"
							cy="13.4118"
							r="2.82353"
							stroke=""
							stroke-width="1.5"
						/>
					</svg>

					<span class="nav__item__label"> {{$t('nav.home')}} </span>
				</a>

				<router-link
					v-if="!this.env.setDefaultLiveRoute || ( env.setDefaultLiveRoute && !getSoccerCount)"
					:class="{
						nav__item: 1,
						nav__item__live: 1,
						active:
							$route.path == '/live' ||
							$route.name == 'live-sport' ||
							$route.name == 'live-markets',
					}"
					to="/live"
					replace
				>
					<svg
						:class="{
							nav__item__icon: 1,
							nav__item__icon__live: 1,
						}"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="4"
							y="4"
							width="15.5"
							height="16"
							rx="7.75"
							stroke-width="1.5"
							stroke-linejoin="round"
						/>
						<path
							d="M14.5 12.866C15.1667 12.4811 15.1667 11.5189 14.5 11.134L11.5 9.40192C10.8333 9.01702 10 9.49815 10 10.2679V13.7321C10 14.5019 10.8333 14.983 11.5 14.5981L14.5 12.866Z"
							stroke-width="1.5"
							stroke-linejoin="round"
						/>
					</svg>

					<span class="nav__item__label">
						{{$t('nav.live')}}
						<span v-if="numberOfLiveMatches > 0"
							>({{ numberOfLiveMatches }})</span
						>
					</span>
				</router-link>

				<router-link
					v-if="this.env.setDefaultLiveRoute && getSoccerCount"
					:class="{
						nav__item: 1,
						nav__item__live: 1,
						active:
							$route.path == '/live/soccer' ||
							$route.name == 'live-sport' ||
							$route.name == 'live-markets',
					}"
					to="/live/soccer"
					replace
				>
					<svg
						:class="{
							nav__item__icon: 1,
							nav__item__icon__live: 1,
						}"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="4"
							y="4"
							width="15.5"
							height="16"
							rx="7.75"
							stroke-width="1.5"
							stroke-linejoin="round"
						/>
						<path
							d="M14.5 12.866C15.1667 12.4811 15.1667 11.5189 14.5 11.134L11.5 9.40192C10.8333 9.01702 10 9.49815 10 10.2679V13.7321C10 14.5019 10.8333 14.983 11.5 14.5981L14.5 12.866Z"
							stroke-width="1.5"
							stroke-linejoin="round"
						/>
					</svg>

					<span class="nav__item__label">
						{{$t('nav.live')}}
						<span v-if="numberOfLiveMatches > 0"
							>({{ numberOfLiveMatches }})</span
						>
					</span>
				</router-link>

				<betslip-button />

				<router-link
					:class="{ nav__item: 1, active: $route.path.indexOf('/mybets') > -1 }"
					to="/mybets"
					exact
					replace
				>
					<svg
						:class="{
							nav__item__icon: 1,
						}"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="4"
							y="4"
							width="15.5"
							height="16"
							rx="5"
							stroke-width="1.5"
							stroke-linejoin="round"
						/>
						<path
							d="M8.44434 8.88892H11.5816"
							stroke-width="1.5"
							stroke-linecap="round"
						/>
						<path
							d="M8.44434 12H15.111"
							stroke-width="1.5"
							stroke-linecap="round"
						/>
						<path
							d="M8.44434 15.1111H15.111"
							stroke-width="1.5"
							stroke-linecap="round"
						/>
					</svg>

					<span class="nav__item__label">{{$t('nav.my-bets')}}</span>
				</router-link>
				<router-link
					:class="{
						nav__item: 1,
						active: $route.path.indexOf('/profile') > -1,
					}"
					to="/profile"
					exact
					replace
				>
					<svg
						:class="{
							nav__item__icon: 1,
						}"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle
							cx="12"
							cy="7"
							r="3"
							stroke-width="1.5"
							stroke-linecap="round"
						/>
						<path
							d="M18 17C18 19.7614 14.7614 20 12 20C9.23858 20 6 19.7614 6 17C6 14.2386 9.23858 12 12 12C14.7614 12 18 14.2386 18 17Z"
							stroke-width="1.5"
							stroke-linecap="round"
						/>
					</svg>

					<span class="nav__item__label">{{$t('nav.profile')}}</span>
				</router-link>
			</nav>
		</footer>
	</div>
</template>

<script>
import BetslipButton from "./BetslipButton.vue";

export default {
	name: "Bottom",
	components: { BetslipButton },
	data() {
		return {
			virtual: false,
		};
	},
	mounted(){
		this.$root.$emit("refresh-live-sports-list");
	},
	computed: {
		numberOfLiveMatches() {
			return this.$store.getters.numberOfLiveMatches;
		},
		betslipCount() {
			const shikishaBaseRoute = window.SHIKISHA_PRODUCT_NAME.replace(
				/\s/,
				"-"
			).toLowerCase();
			let count = this.$store.getters.betSlipCount;
			if (this.$route.name == shikishaBaseRoute)
				count = this.$store.getters.jengabetBetSlipCount;
			if (this.$route.path.indexOf("/virtuals") > -1)
				count = this.$store.getters.virtualBetslipCount;
			if (this.$route.path.indexOf("/turudi-uwanjani") > -1)
				count = this.$store.getters.boostedBetslipCount;
			return count;
		},
		betslipUrl() {
			let url = "/betslip";
			const shikishaBaseRoute = window.SHIKISHA_PRODUCT_NAME.replace(
				/\s/,
				"-"
			).toLowerCase();
			if (this.$route.name == shikishaBaseRoute) url = "/betslip?type=shikisha";
			if (this.$route.path.indexOf("/virtuals") > -1)
				url = "/betslip?type=virtual";
			if (this.$route.path.indexOf("/turudi-uwanjani") > -1)
				url = "/turudi-uwanjani/betslip";
			return url;
		},
		authenticated() {
			return this.$store.getters.authenticated;
		},
		getSoccerCount() {
		let vm = this;
		let liveData = {};
		let soccer = {};
		let soccerLive = 0;
		if(this.$store.getters.liveSports.data){
			liveData = vm.$store.getters.liveSports.data;
			soccer = liveData.find(sport => sport.sport_name === "Soccer");
			soccerLive = soccer ? { sport_name: soccer.sport_name, count: soccer.count } : 0;
		}
		return soccerLive.count > 0 ? true : false;
		},
	},
	methods: {
		toggleSearch() {
			this.$store.commit("toggleSearch");
		},
		goTo(location, option) {
			if (option == "home") {
				console.log("[bottom::goTo] Clicked home");
				let clickHomeBottomNavEvent = new Event("clickHomeBottomNavEvent");
				window.dispatchEvent(clickHomeBottomNavEvent);
			}
			this.$router.replace(location);
		},
	},
};
</script>

<style lang="scss">
footer {
	position: relative;
	z-index: 99999;
	.nav {
		max-width: var(--app-width);
		position: fixed;
		bottom: 0;
		width: 100%;
		height: var(--margin-bottom);
		background-color: var(--white);
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		text-align: center;
		font-size: var(--font-medium);
		text-transform: capitalize;
		box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		color: var(--light-black);
		transition: bottom 400ms ease-in-out;
		&--hidden {
			bottom: -50px;
		}
		&__item {
			padding: 5px;
			width: 25%;
			text-align: center;
			cursor: pointer;
			font-size: var(--font-medium);
			@media (max-width: 320px) {
				font-size: var(--font-small);
			}
			font-weight: var(--font-weight-lighter);
			display: flex;
			flex-direction: column;
			align-items: center;
			text-decoration: none;
			color: var(--light-black);
			&__label{
				font-size: 12px;
			}
			&__icon {
				height: 24px;
				margin-bottom: 5px;
				stroke: var(--light-black);
				&__live {
					circle {
						fill: var(--light-black);
					}
					polygon {
						fill: var(--white);
					}
				}
			}
			&.active {
				font-weight: var(--font-weight-medium);
				color: var(--green);

				path,
				rect,
				circle {
					stroke: var(--green);
					stroke-width: 1.8px;
				}

				&.nav__item__live {
					color: var(--red);

					rect,
					path {
						stroke: var(--red);
					}
				}
				.nav__item__icon {
					fill: transparent; //var(--green);
				}
				.nav__item__icon__live {
					fill: none;
					color: var(--red);
					circle {
						fill: var(--red);
					}
				}
			}

			&--container {
				position: relative;
			}
		}
		&.authenticated {
			&--item {
				width: 20%;
			}
		}
		&__betslip {
			margin: -7px auto;
			background: var(--yellow);
			color: var(--always-black);
			height: 55px;
			border-radius: 50%;
			width: 55px;
			font-weight: var(--font-weight-medium);
			font-size: var(--font-large);
			border: none;
		}
	}
}
</style>
